/*  ========================================================================
    # Components - Image Slider - PreloadImage
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';

const PreloadImage = ({ defaultSrc, srcSet, width, inView = false }) => (
  <img
    style={{
      opacity: 0,
      visibility: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: -999,
      inset: 0,
      width: '100%',
      height: '100%'
    }}
    srcSet={inView ? srcSet : ''}
    sizes={`${width}px`}
    src={inView ? defaultSrc : ''}
    aria-hidden
  />
);

PreloadImage.propTypes = {
  defaultSrc: PropTypes.string,
  srcSet: PropTypes.string,
  width: PropTypes.number,
  inView: PropTypes.bool
};

export default PreloadImage;
